import { useCallback, useState } from 'react';

/**
 * Owns which appointment the EventDetailsPanel is showing, and remembers whether
 * that appointment was just scheduled by the admin so the panel can nudge them
 * to take a payment for it.
 *
 * `detailsProps` is meant to be spread onto <EventDetailsPanel>.
 */
export default function useSelectedEvent() {
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [justScheduledId, setJustScheduledId] = useState(null);

    const selectEvent = useCallback(event => {
        setJustScheduledId(null);
        setSelectedEvent(event);
    }, []);

    function showScheduledEvent(events) {
        // Scheduling several appointments at once has no single event to show
        if (!Array.isArray(events) || events.length !== 1) {
            return;
        }

        setJustScheduledId(events[0].id);
        setSelectedEvent(events[0]);
    }

    return {
        selectedEvent,
        selectEvent,
        showScheduledEvent,
        detailsProps: {
            event: selectedEvent,
            isOpen: !!selectedEvent,
            justScheduled:
                !!selectedEvent && selectedEvent.id === justScheduledId,
            onClose: () => selectEvent(null),
        },
    };
}
